import React, { useState } from "react";
import { InputGroup, Image } from "react-bootstrap";
import { FormControlSearch } from "../../../components";
import { isEmpty, isNull } from "lodash";
import { useFormikContext } from "formik";

const VariableListSlider = ({
  index,
  objName,
  variableList,
  setOpenSlider,
  fieldName,
}) => {
  const { setFieldValue } = useFormikContext();
  const [filteredData, setFilteredData] = useState(variableList);

  const searchItems = (searchValue) => {
    const filteredValues = variableList.filter((item) => {
      return Object.values(item)
        .join("")
        .toLowerCase()
        .includes(searchValue.trim().toLowerCase());
    });
    setFilteredData(filteredValues);
  };

  const onSelectClick = (item) => {
    isNull(index)
      ? setFieldValue(`${objName}.value`, {
          id: item.id,
          displayName: item.displayName,
          propertyName: item.propertyName,
          dataType: item.dataType,
          datum: item.datum,
        })
      : setFieldValue(`${fieldName}.value`, {
          id: item.id,
          displayName: item.displayName,
          propertyName: item.propertyName,
          dataType: item.dataType,
          datum: item.datum,
        });
    setOpenSlider(false);
  };

  return (
    <>
      <div>
        <p className="ft-14 fw-500 mb-3 mt-2">Select Variable</p>
        <div className="border-line-seperator mb-3" />
        <input
          icon="search"
          className="searchBox"
          placeholder="Search source fields here"
          onChange={(e) => searchItems(e.target.value)}
        />

        <div className="function-list-container mt-2">
          {!isEmpty(filteredData) &&
            filteredData.map((item) => {
              return (
                <div
                  className="function-list cursor-pointer"
                  onClick={() => {
                    onSelectClick(item);
                  }}
                >
                  <div className="d-flex flex-column justify-content-between">
                    <p className="ft-14 mb-1">{item.displayName}</p>
                    <p className="ft-12 mb-1">{item.datum}</p>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default VariableListSlider;
